import { VStack } from "@leplein/ui";
import { PropsWithChildren } from "react";

interface MainLayoutProps extends PropsWithChildren {}

export const MainLayout = ({ children }: MainLayoutProps) => (
	<main className="justify-center items-center flex flex-col z-0 min-h-dvh">
		<VStack className="justify-between p-4 flex-1 w-full">{children}</VStack>
	</main>
);
